// src/utils/security.js

// Sanitiza texto para evitar XSS
export const sanitizeText = (text) => {
    if (!text) return '';
    return text
      .replace(/[<>]/g, '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;');
  };
  
  // Sanitiza URLs
  export const sanitizeUrl = (url) => {
    if (!url) return '';
    try {
      const parsed = new URL(url);
      return ['http:', 'https:'].includes(parsed.protocol) ? url : '';
    } catch {
      return '';
    }
  };
  
  // Sanitiza e valida cores
  export const validateColor = (color) => {
    if (!color) return '';
    const hexColorRegex = /^#[0-9A-Fa-f]{6}$/;
    return hexColorRegex.test(color) ? color : '';
  };
  
  // Sanitiza nomes de arquivo
  export const sanitizeFilename = (filename) => {
    if (!filename) return '';
    return filename.replace(/[^a-zA-Z0-9.-]/g, '');
  };
  
  // Valida score NPS
  export const validateNPSScore = (score) => {
    const numScore = Number(score);
    return !isNaN(numScore) && numScore >= 0 && numScore <= 10;
  };
  
  // Valida dados da empresa
  export const validateCompanyData = (company) => {
    return company && 
           typeof company === 'object' && 
           Number.isInteger(company.id) && 
           company.id > 0 && 
           typeof company.name === 'string';
  };